import React from "react";

interface ChevronDownIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  rotate?: "left" | "up" | "right" | "down";
  color?: string;
  transition?: boolean;
  className?: string;

  onClick?: () => void;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({
  size = "16px",
  transition,
  onClick,
  className,
  rotate = "down",
  color = "#1E1E1E",
  ...props
}) => {
const getRotateDeg = (val: "left" | "up" | "right" | "down"): string => {
  switch (val) {
    case "down":
      return "0";     // default
    case "right":
      return "90";
    case "up":
      return "180";
    case "left":
      return "270";
    default:
      return "0";
  }
};


  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transition: transition ? "transform 0.2s ease-in-out" : "",
        transform: `rotate(${getRotateDeg(rotate)}deg)`,
      }}
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        d="M13.2797 5.96667L8.93306 10.3133C8.41973 10.8267 7.57973 10.8267 7.06639 10.3133L2.71973 5.96667"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDownIcon;
